/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zotero_Libraries_SubtitleInputs */

const en_zotero_libraries_subtitle = /** @type {(inputs: Zotero_Libraries_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal and group libraries`)
};

const es_zotero_libraries_subtitle = /** @type {(inputs: Zotero_Libraries_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliotecas personales y de grupo`)
};

/**
* | output |
* | --- |
* | "Personal and group libraries" |
*
* @param {Zotero_Libraries_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_libraries_subtitle = /** @type {((inputs?: Zotero_Libraries_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Libraries_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_libraries_subtitle(inputs)
	return en_zotero_libraries_subtitle(inputs)
});